module.exports = __webpack_public_path__ + "static/img/2_1_1_2.cae8bc09.jpg";